import { render, staticRenderFns } from "./OmxPageHeader.vue?vue&type=template&id=f9723ad2&scoped=true"
import script from "./OmxPageHeader.vue?vue&type=script&lang=js"
export * from "./OmxPageHeader.vue?vue&type=script&lang=js"
import style0 from "./OmxPageHeader.vue?vue&type=style&index=0&id=f9723ad2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9723ad2",
  null
  
)

export default component.exports